import { sanitizeTags } from "@components/utils/sanitizeHelpers";
import { IActivityResponse } from "@customTypes/modelResponses";
import useSliderRefresh from "@hooks/useSliderRefresh";
import ModalCard from "@libs/cards/ModalCard";
import { useCallback, useEffect } from "react";
import ViewAllLayout from "./ViewAllLayout";

interface ViewAllActivitiesLayoutProps {
  title: string;
  viewAllActivities: boolean;
  openViewAllActivities: (shouldOpen: boolean) => void;
  viewAllActivitesData: IActivityResponse[];
}

function ViewAllActivitiesLayout({
  title,
  viewAllActivities,
  openViewAllActivities,
  viewAllActivitesData,
}: ViewAllActivitiesLayoutProps): JSX.Element {
  const { sliderRefresh, setSliderRefresh } = useSliderRefresh();

  useEffect(() => {
    if (viewAllActivities) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
      document.body.style.position = "initial";
    }

    return () => {
      document.body.style.overflow = "unset";
      document.body.style.position = "initial";
    };
  }, [viewAllActivities]);

  const onExploreAllClick = useCallback(() => {
    openViewAllActivities(false);
    if (setSliderRefresh) {
      setSliderRefresh(!sliderRefresh);
    }
  }, [sliderRefresh]);

  return (
    <ViewAllLayout
      title={"Things to do in " + title}
      onCloseHandler={onExploreAllClick}
    >
      {/* Activity cards section */}
      {viewAllActivitesData.map((activity) => (
        <div className="w-full" key={activity.id}>
          <ModalCard
            id={activity?.id}
            title={activity?.Title}
            subtitle={title}
            blurb={activity?.Blurb}
            url={activity?.SEO?.Slug}
            // opensNewTab
            tags={sanitizeTags(activity?.tags)}
            images={activity?.Media?.PrimaryImage}
            imageSize={"small"}
            isHorizontal
            hasLike
            cardType="activity"
            linkTitle={"View Activity"}
          />
        </div>
      ))}
    </ViewAllLayout>
  );
}

export default ViewAllActivitiesLayout;
